module.exports = __webpack_public_path__ + "static/media/icon-tiktok.f3c96803.svg";